module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/2/2-29df92a76d0af1366d656df21eebba37.jpg";